export default {
    maps: {
        errorMessages: {
            export: "Error al exportar datos",
            noDeviceFound: "No se encontraron dispositivos coincidentes",
            fetchRadios: "Error al recuperar datos de radio",
            fetchRadiosAndTowers: "Error al recuperar datos de radio y Estación base",
            fetchRadio: "Error al recuperar datos de radio para: {id}",
            fetchTower: "Error al recuperar los datos de la Estación base para: {id}",
            fetchRoutes: "Error al recuperar los datos de ruta para: {id}",
            towersCreateSetMaxIds: 'Demasiadas Estación base seleccionadas. Se puede seleccionar un máximo de {cnt} Estación base al crear un conjunto',
            radiosCreateSetMaxIds: 'Demasiadas radios seleccionadas. Se puede seleccionar un máximo de {cnt} radios al crear un conjunto',
            fetchBuddyOrds: "Error al obtener información de amigos o ord"
        },
        controls: {
            baseStations: {
                name: "Salud de la estación base",
                healthStatistic: "Estadísticas de salud",
                alarmState: "Estado de alarma",
                ackCount: "Acks",
                messageDuplicateCount: "Duplicar mensajes de amigos",
                messageBuddyCount: "Mensajes únicos de amigos",
                messageInboundCount: 'Comandos de enlace descendente recibidos',
                messageOutboundCount: 'Comandos de enlace descendente en cola',
                uplinkCount: "Mensaje de enlace ascendente enviado",
                towerTransmit: "Conteo de transmisión de la Estaciones Base",
                transmitSlot: 'Ranura de Transmisión',
                singleRouteRadioCount: 'Rutas diarias de enlace ascendente único',
                tooltip: 'Deshabilitada para la mejor estadística de Estación base escuchada'
            },
            radios: {
                healthStatistic: "Estadísticas de salud",
                snrDaily: "SNR Diario ",
                towersHeardDaily: "Estaciones base escuchadas diariamente",
                routeCountDaily: "La ruta cuenta diariamente",
                alarmState: "Estado de alarma",
                bestTowerHeard: "La mejor Estación base escuchada",
                activeAlarmsCounts: 'Recuentos de alarmas activas',
                receiveFrequency: "Frecuencia de recepción",
                l2ACKSuccess: "L2Ack Éxito %",
                l2ACKThroughput: "L2Ack Rendimiento %",
                outageTracking: "Seguimiento de interrupciones",
                arqivaTitles: {
                    routeCountDaily: "Ruta de enlace ascendente",
                    towersHeardDaily: "Estaciones base escuchadas",
                    snrDaily: 'SNR del punto final de enlace ascendente'
                },
                outageLevels: {
                    restored: "Restaurado",
                    "30M": "30M",
                    "1HR": "1HR",
                    "12HR": "12HR",
                    "24HR": "24HR",
                    "72HR+": "72HR+"
                }
            },
            lastHeard: "Último escuchado",
            baseStationFilter: 'Filtro de estación base',
            radioFilter: 'Filtro de radio',
            stale: "Duro",
            na: "NA",
            zoomIn: "Acercar",
            zoomOut: "Alejar",
            zoomExtents: "Ajustar al tamaño",
            export: "Exportar Datos",
            selectByPolygon: "Seleccionar por polígono",
            selectByDrawing: "Seleccionar por dibujo",
            clearDrawingSelected: "Borrar dibujo / seleccionado",
            selectHelp: "Seleccione Ayuda",
            addToSet: "Agregar elementos seleccionados para configurar",
            createSet: "Crear conjunto a partir de elementos seleccionados"
        },
        clickToDisplayMap: {
            tower: "Haga clic para visualizar el mapa de la estación base",
            radio: "Haga clic para visualizar el mapa de radio"
        },
        loading: "Cargando...",
        dots: "puntos",
        sectors: "Sectores",
        routes: "Rutas",
        searchPlaceholder: "Buscar en el mapa...",
        searchPlaceholderExact: "Búsqueda exacta en el mapa...",
        detailMapSearchPlaceholder: "Buscar dentro de 3 millas...",
        detailMapSearchPlaceholderExact: "Búsqueda exacta dentro de 3 millas...",
        detailMapSearchNoMatches: "No se encontraron coincidencias en 3 millas",
        detailMapSearchSearching: "Búsqueda de coincidencias en un radio de 3 millas...",
        detailMapSearchSearchingExact: "Búsqueda de coincidencias exactas dentro de 3 millas...",
        globalMap: "Mapa global",
        fetchMoreRadios: "Conseguir más radios",
        radioFetchText: "Mostrando {radioCount} a {radioTotalCount} radios con coordenadas válidas",
        radioFetchHiddenText: "Radios ocultas por la usuaria",
        refreshActive: "Actualizaciones de página cada {refreshRate} minutos, {lastUpdate}",
        refreshPaused: "Actualización automática pausada",
        mapView: "Vista del mapa",
        mapSelection: {
            routeAll: "Ruta últimos {routeRetention} días",
            route: "Ruta Día Ultimo",
            nearby: "Cerca",
            downlinkRouteAll: "Ruta de enlace descendente últimos {routeRetention} días",
            downlinkRoute: "Último día de ruta de enlace descendente"
        },
        mapViewTop10: {
            top10: "10 mejores",
            all: "Todo"
        },
        infoBox: {
            channel: "Canal",
            towersHeardDaily: "Estaciones base escuchadas",
            bestTowerHeard: "Mejor Estación base de enlace ascendente",
            bestTowerDownlink: "Mejor Estación base de enlace descendente",
            routeCountDaily: "La ruta cuenta",
            routes: "Rutas",
            routeName: "Ruta",
            routeDestinationId: "Destino de la ruta - {id}",
            routeSourceId: "Origen de la ruta de enlace descendente - {id}",
            routeDestinationName: "Destino de la ruta",
            routeLastUsedDateTime: "Utilizado por última vez:  {lastUsedDateTime}",
            frequency: "Frecuencia",
            frequencyName: "Nombre de frecuencia",
            lastUsed: "Utilizado por última vez",
            lastUpdated: "Última actualización",
            lastL2ACK: "Último L2 ACK",
            lastFiveRoutes: "Últimos 5 utilizados",
            avgUsageCount: "Recuento promedio de uso diario",
            SNR: "SNR diario promedio",
            signalStrength: "Intensidad de señal diaria promedio",
            baseStationId: "Idendificacion de Estaciones Base: ",
            baseStationNoName: "TGB #{id} - Sin Nombre",
            baseStationType: "Tipo de Estaciones Base: ",
            baseStationLastHeardDateTime: "Escuchado por última vez: {lastHeardDateTime}",
            endpointId: "Punto Final ID: ",
            endpointIdWithRepId: "Punto Final ID: #{id}",
            endpointType: "Tipo de Dispositivo: {endpointDeviceType}",
            endpointReceiveMode: "Modo de Recibido / transmitido: {receiveMode}",
            endpointLastHeardDateTime: "Escuchado por última vez: {lastHeardDateTime}",
            endpointRIS: "Rendimiento de lectura: {ris}",
            notAvailable: "No Disponible",
            selectedItems: "Artículos seleccionados",
            kfactor: "K-Factor",
            xmitSlot: "Ranura de transmisión",
            random: "Aleatorio",
            cluster: {
                clusterNum: "Cuenta de Cosas: ",
                clusterName: "Cracimo",
                clusterNumDynamic: "Número de items:  {numItems}",
                zoomToViewMore: "Acercar para ver más detalles"
            },
            locationEstimated: "ubicación estimada",
            distance: "Distancia",
            miles: "millas",
            distanceBetweenInMiles: "Distancia {distance} millas",
            bullseyeTitle: "Mostrar distancias de 1, 3, 5 y 10 millas",
            routesCount: "Rutas: {count}",
            baseStationsCount: "Estaciones Base: {count}",
            radiosCount: "Radios: {count}",
            clustersCount: "Racimos: {count}",
            towerSectorInfo: "{startingAzimuth}° - {endingAzimuth}° ({sector})"
        },
        mapViewHelp: {
            routeTitle: "Vista de mapa - Ruta Dario",
            routeSubTitle30: "Últimos  {routeRetentionDays} Dias: Rutas utilizadas en ultimos  {routeRetentionDays} dias.",
            routeSubTitleDaily: "Último Dia: Rutas utilizadas en último día calendario completado.",
            nearbyTitle: "Vista del mapa: cerca",
            snrArrowHelpText: "El tono de gris está relacionado con SNR. Cuanto mayor sea la SNR promedio, más oscuro será el color gris utilizado.",
            routesUsedHelpText: "El ancho de la flecha de ruta está relacionado con el número de veces que se usa, cuanto más ancha es la línea, mayor es el número de veces que se usa.",
            nearbyHelpText: "La vista cercana mostrará las estaciones base y las radios en un radio de tres millas.",
            top3rd: "3er superior",
            middle3rd: "3er medio",
            bottom3rd: "3er inferior",
            mostUsedRoute: "Ruta más utilizada",
            top10Toggle: "El interruptor se puede usar para cambiar entre la vista normal de todas las rutas y solo las 10 rutas principales (basadas en SNR)."
        },
        mapDrawingHelp: {
            drawingHelpTitle: "Ayuda de acciones",
            drawingHelpBody: "Este menú contiene diferentes acciones que le permiten seleccionar radios y estaciones base, borrar sus dibujos y todos los elementos de selección, y agregar todos los elementos seleccionados a un Conjunto.",
            selectByPolygon: "Use el botón izquierdo del mouse para crear un punto diferente en un polígono para seleccionar radios y estaciones base. Haga clic derecho en cualquier parte del mapa para terminar.",
            selectByDrawing: "Mantenga presionado el botón izquierdo del mouse y mueva el mouse para comenzar a dibujar para seleccionar radios y estaciones base. Una vez que haya terminado, simplemente suelte el botón izquierdo del mouse.",
            clearDrawingSelected: "Esto borrará cualquier dibujo que haya creado, junto con borrar todos los elementos seleccionados.",
            createSet: "Tome todos los elementos seleccionados y agréguelos a un nuevo conjunto.",
            addToSet: "Tome todos los elementos seleccionados y agréguelos a un conjunto existente."
        },
        mapOverlay: {
            overlayTitle: "Acercarse",
            overlayText: "Acerque o agregue un filtro de radio para ver las radios."
        },
        detailActionsSubTitle: 'Acciones de mapa'
    }
}
